<template>
  <div>
    <oie-page-container-shell v-show="!selectedUserData && !showImportCustomer && !hasSelectedGiftCard">
      <template slot="header">
        {{ t('superuserManageCustomerHeader') }}
      </template>

      <template slot="main">
        <vue-tabs
          ref="tabs"
          v-model="activeTab"
          v-element-loader="{ endpoint: ['cart/uploadFile', 'cart/addToCart'] }">
          <v-tab :title="t('superuserSearchCustomerHeader')">
            <template>
              <oie-superuser-search></oie-superuser-search>
            </template>
          </v-tab>

          <v-tab title="Importera kund">
            <template>
              <oie-superuser-import-customer></oie-superuser-import-customer>
            </template>
          </v-tab>
          <v-tab title="Sök produkter">
            <template>
              <oie-superuser-search-product></oie-superuser-search-product>
            </template>
          </v-tab>
          <v-tab title="Retur av anonym order">
            <template>
              <oie-superuser-anonymous-order-return></oie-superuser-anonymous-order-return>
            </template>
          </v-tab>
          <v-tab title="Presentkort">
            <template>
              <oie-superuser-gift-card></oie-superuser-gift-card>
            </template>
          </v-tab>
        </vue-tabs>
      </template>
    </oie-page-container-shell>

    <oie-page-container-shell v-if="hasUser">
      <template slot="header">
        {{ t('superuserChangeCustomerHeader') }}
      </template>

      <template slot="main">
        <oie-superuser-my-account-customer-data :selected-user-data="selectedUserData" :selected-user-index="selectedUserIndex"></oie-superuser-my-account-customer-data>
      </template>
    </oie-page-container-shell>

    <oie-page-container-shell v-if="hasSelectedGiftCard">
      <template slot="header">
        Hantera presentkort
      </template>

      <template slot="main">
        <oie-superuser-gift-card-details :selected-gift-card="selectedGiftCardData" :selected-gift-card-index="selectedGiftCardIndex"></oie-superuser-gift-card-details>
      </template>
    </oie-page-container-shell>
  </div>
</template>

<script>
import { VueTabs, VTab } from 'vue-nav-tabs/dist/vue-tabs.js'

export default {
  components: {
    VueTabs,
    VTab
  },
  data: () => ({
    activeTab: null,
    selectedUserData: null,
    selectedUserIndex: null,
    showImportCustomer: false,
    selectedGiftCardData: null,
    selectedGiftCardIndex: null
  }),
  computed: {
    hasUser() { return this.selectedUserData && this.selectedUserIndex !== null },
    hasSelectedGiftCard() { return this.selectedGiftCardData && this.selectedGiftCardIndex !== null }
  },
  mounted() {
    this.subscribe('superuser-edit-user-data', ({ user, index }) => {
      this.selectedUserData = user
      this.selectedUserIndex = index
    })

    this.subscribe('superuser-reset-user-data', () => {
      this.selectedUserData = null
      this.selectedUserIndex = null
    })

    this.subscribe('superuser-user-updated', ({ user, index }) => {
      this.selectedUserData = user
      this.selectedUserIndex = index
    })

    this.subscribe('superuser-update-and-reset-user-data', () => {
      this.selectedUserData = null
      this.selectedUserIndex = null
    })

    this.subscribe('superuser-edit-gift-card', ({ giftcard, index }) => {
      this.selectedGiftCardData = giftcard
      this.selectedGiftCardIndex = index
    })

    this.subscribe('superuser-reset-gift-card-data', () => {
      this.selectedGiftCardData = null
      this.selectedGiftCardIndex = null
    })
  }
}
</script>
